package top.wcpe.allincore.ui.runtime.style

import top.wcpe.allincore.ui.runtime.render.model.GradientStop
import kotlin.jvm.JvmName

/**
 * 填充画刷：纯色 / 线性渐变 / 径向渐变。
 *
 * 对齐 Compose 的 `Brush` 抽象，替代 [StyleVisual] 中散落的 gradient* 字段——
 * 填充意图收敛为一个值类型，由 [VisualModifier.Surface] 持有。
 */
sealed interface Brush {

    /** 纯色填充（ARGB）。 */
    data class Solid(@get:JvmName("color") val color: Int) : Brush

    /** 线性渐变：停靠点 + 角度（弧度）。 */
    data class Linear(
        @get:JvmName("stops") val stops: List<GradientStop>,
        @get:JvmName("angleRadians") val angleRadians: Float,
    ) : Brush

    /** 径向渐变：停靠点 + 归一化中心（0..1）+ 相对短边的半径比例。 */
    data class Radial(
        @get:JvmName("stops") val stops: List<GradientStop>,
        @get:JvmName("centerX") val centerX: Float,
        @get:JvmName("centerY") val centerY: Float,
        @get:JvmName("radius") val radius: Float,
    ) : Brush
}
